import getParams from './getParams'
import getCountries from './getCountries'
import getNewsLetter from './getNewsLetter'
import getNewsGesintel from './getNewsGesintel'
import getOptions from './getOptions'
import importSelected from './importSelected'
import getC57FormHistory from './getC57FormHistory'
import getCausasPenalesDetail from './getCausasPenalesDetail'
import excelCategoriasDelitos from './excelCategoriasDelitos'
import updateCategoriaDelito from './updateCategoriaDelito'
import uploadCategoriasDelitos from './uploadCategoriasDelitos'

export const getParamsPromise = getParams
export const getCountriesPromise = getCountries
export const getNewsLetterPromise = getNewsLetter
export const getNewsGesintelPromise = getNewsGesintel
export const getOptionsPromise = getOptions
export const importSelectedPromise = importSelected
export const getC57FormHistoryPromise = getC57FormHistory
export const getCausasPenalesDetailPromise = getCausasPenalesDetail
export const excelCategoriasDelitosPromise = excelCategoriasDelitos
export const updateCategoriaDelitoPromise = updateCategoriaDelito
export const uploadCategoriasDelitosPromise = uploadCategoriasDelitos